import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const NORMALIZE_LINES_MUTATION = gql`
  mutation normalizeLines(
    $documentVersion: DocumentVersionInput!
    $lineIds: [String!]
  ) {
    normalizeLines(documentVersion: $documentVersion, lineIds: $lineIds)  {
      documentId
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class NormalizeLinesMutation extends Mutation<RootMutation> {
  document = NORMALIZE_LINES_MUTATION;
}
